export enum LogLevel {
  TRACE = 0,
  DEBUG = 1,
  INFO = 2,
  WARN = 3,
  ERROR = 4,
  FATAL = 5,
}
export enum LogType {
  PAGE,
  COMPONENT,
  BUTTON,
  TOKEN,
}

export enum ActionType {
  LOGIN,
  LOGOUT,
  NEW_SESSION,
  SESSION_EXPIRED,
  PAGE_CLOSED,
  OPEN_PAGE,
  TAB_CLOSED,
  PAGE_UPDATE,
  OTHER,
}
